import React from 'react'

const NavContext = React.createContext({
  active: null,
  setActive: () => {},
  mobileMenuIsOpen: false
})

/**
 * A simple higher order component that maps the context data onto the the component's props.
 *
 * @param {any} Component
 */
export const withActiveLink = Component => props => (
  <NavContext.Consumer>
    {({ active, setActive, mobileMenuIsOpen }) => <Component activeLink={active} setActiveLink={setActive} mobileMenuIsOpen={mobileMenuIsOpen} {...props} />}
  </NavContext.Consumer>
)

export default NavContext
